<template>
  <div>
    <v-btn color="primary" v-if="!edit" @click="edit = !edit" large class="mb-3">{{ $t('Edit profile') }}</v-btn>

    <v-card
        class="mx-auto"
        max-width="900"
        outlined
    >
        <v-card-text>
            <alert />
            <v-form
            ref="formProfile"
            v-model="valid"
            :disabled="!edit"
            lazy-validation>
                <h2 class="mb-5">{{ $t('Basic Information') }}</h2>
                <v-row>
                    <v-col md="6" cols="12">
                        <v-text-field
                            v-model="form.name"
                            :label="$t('Name')"
                            :rules="rules.name"
                            outlined
                            dense
                            hide-details="auto"
                        />
                    </v-col>
                   <v-col md="6" cols="12">
                       <v-text-field
                            v-model="form.mobile"
                            :label="$t('Mobile number')"
                            placeholder="0987654321"
                            :rules="rules.mobile"
                            outlined
                            dense
                            hide-details="auto"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col md="6" cols="12">
                        <datepicker v-model="form.birthday" :label="$t('Birthday')"/>
                    </v-col>
                   <v-col md="6" cols="12">
                       <v-select
                            :items="genders"
                            :label="$t('Gender')"
                            v-model="form.gender"
                            :item-text="__attr"
                            outlined
                            dense
                            hide-details="auto"
                        ></v-select>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                       <v-text-field
                            v-model="form.job_title"
                            :label="$t('Job title')"
                            outlined
                            dense
                            hide-details="auto"
                        />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-textarea rows="2" :label="$t('Address')"
                        :rules="rules.address"
                        outlined
                        v-model="form.address"
                        hide-details="auto"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                      <v-file-input
                        dense
                        outlined
                        clearable
                        prepend-icon=""
                        append-icon="mdi-camera"
                        v-model="form.avatar_upload"
                        :rules="rules.avatar_upload"
                        accept=".jpeg,.jpg,.png,.gif"
                        :label="$t('Upload avatar')"
                        hide-details="auto"
                        @change="changeAvatar"
                      ></v-file-input>
                    </v-col>
                    <v-col cols="12" sm="6">
                       <v-avatar
                        v-if="avatarSource"
                        color="grey"
                        size="200"
                        tile
                      >
                        <v-img :src="previewAvatar ? previewAvatar : avatarSource"></v-img>
                      </v-avatar>
                    </v-col>
                </v-row>
                <h2 class="my-5">{{ $t('Account') }}</h2>
                <v-row>
                    <v-col md="6" cols="12">
                        <v-text-field
                            :value="profile.username"
                            :label="$t('Username')"
                            outlined
                            dense
                            hide-details="auto"
                            readonly
                        />
                    </v-col>
                     <v-col md="6" cols="12">
                        <v-text-field
                            :value="__attr(profile.role)"
                            :label="$t('Role')"
                            outlined
                            dense
                            hide-details="auto"
                            readonly
                        />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col md="6" cols="12">
                        <v-text-field
                            v-model="form.password"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="showPassword ? 'text' : 'password'"
                            :rules="rules.password"
                            outlined
                            dense
                            hide-details="auto"
                            :label="$t('Password')"
                            @click:append="showPassword = !showPassword"
                        ></v-text-field>
                    </v-col>
                    <v-col md="6" cols="12">
                        <v-text-field
                            v-model="form.password_confirmation"
                            :append-icon="showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="showPasswordConfirmation ? 'text' : 'password'"
                            :rules="rules.password_confirmation"
                            outlined
                            dense
                            hide-details="auto"
                            :label="$t('Password confirmation')"
                            @click:append="showPasswordConfirmation = !showPasswordConfirmation"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
    </v-card>

    <div class="text-center my-5">
        <v-btn color="secondary" v-if="edit" @click="edit = !edit" :disabled="submitted" large class="mr-3">{{ $t('Cancel') }}</v-btn>
        <v-btn color="primary" v-if="edit" @click="submit($event)" :disabled="submitted" large>{{ $t('Submit') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { get, call } from 'vuex-pathify'
import Datepicker from '@/components/Datepicker'
import Validation from '@utils/validation'
import Alert from '@components/Alert'

export default {
  name: 'ProfileIndex',
  components: {
    Datepicker, Alert
  },
  data: (vm) => ({
    edit: false,
    submitted: false,
    valid: true,
    showPassword: false,
    showPasswordConfirmation: false,
    avatarSource: null,
    previewAvatar: null,
    form: {
      name: null,
      mobile: null,
      gender: null,
      job_title: null,
      birthday: null,
      address: null,
      password: null,
      password_confirmation: null,
      avatar_upload: null
    },
    rules: {
      name: [
        (v) => Validation.required(v),
        (v) => Validation.minlength(v, 3)
      ],
      mobile: [
        (v) => Validation.digits(v),
        (v) => Validation.minlength(v, 9),
        (v) => Validation.maxlength(v, 12)
      ],
      address: [
      ],
      password: [
        (v) => Validation.minlength(v, 6)
      ],
      password_confirmation: [
        (v) => Validation.requiredIf(v, () => {
          return !!vm.form.password
        }),
        (v) => Validation.equalTo(v, function() {
          return vm.form.password
        })
      ],
      avatar_upload: [
        (v) => Validation.accept(v, 'image'),
        (v) => Validation.filesize(v, 10 * 1024 * 1024)
      ]
    }
  }),
  computed: {
    profile: get('user/profile'),
    ...get('common', [
      'genders'
    ])
  },
  created() {
    this.attachProfileToForm(this.profile)
  },

  methods: {
    hideAlert: call('alert/hide'),
    showNotify: call('notify/show'),
    loading: call('app/setLoading'),
    handleSubmit: call('user/updateProfile'),
    async submit(e) {
      e.preventDefault()
      const valid = this.$refs.formProfile.validate()
      if (!valid) {
        this.showNotify(this.$t('Please check data before submit!'))
        window.scrollTo(0, 0)
        return false
      } else {
        const formData = {
          ...this.form
        }
        this.submitted = true
        this.hideAlert()
        this.loading(true)
        const response = await this.handleSubmit(formData)
        this.loading(false)
        this.submitted = false
        if (response) {
          const { data, message } = response
          this.showNotify(message)
          this.attachProfileToForm(data.user)
          this.edit = false
        }
        window.scrollTo(0, 0)
      }
    },
    attachProfileToForm(user) {
      const {
        name, mobile, gender, birthday, address
      } = user
      this.$set(this, 'form', {
        name,
        mobile,
        gender,
        birthday,
        job_title: user.job_title,
        address,
        password: null,
        password_confirmation: null
      })
      this.avatarSource = user.avatar_source
      this.previewAvatar = null
    },
    changeAvatar(file) {
      if (file) {
        const url = URL.createObjectURL(file)
        this.previewAvatar = url
      } else {
        this.previewAvatar = null
      }
    }
  }
}
</script>
